<template>
  <div class="p-2 sm:p-6 w-full h-full flex flex-col gap-3 sm:gap-5 " style="min-height: calc(100vh - 100px)">

<!-- Toast Notifications -->
<Toast />
<!-- Modal -->
<Modal />
<!-- Upgrade Modal -->
<Upgrade />

<!-- Header -->
<div class="flex flex-col sm:flex-row items-start justify-between gap-3 sm:gap-2 pb-4 border-b border-gray-200">
 <div class="flex items-start gap-3 w-full sm:w-auto">
   <div class="flex-1 sm:flex-initial">
     <h3 class="font-semibold text-lg sm:text-xl text-gray-900">{{ t('formychat_woocommerce_buttons') }}</h3>
     <p class="text-xs sm:text-sm text-gray-500 mt-1">{{ t('woocommerce_subtitle') }}</p>
   </div>
   <!-- Mobile Menu Button -->
   <button
     @click="showMobileMenu = !showMobileMenu"
     class="md:hidden flex items-center justify-center w-8 h-8 rounded bg-gray-100 hover:bg-gray-200 transition-colors flex-shrink-0"
   >
     <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
       <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
     </svg>
   </button>
 </div>
  <div class="fm-header-actions hidden sm:flex items-center gap-2 lg:gap-3">
    <a href="https://www.youtube.com/watch?v=bjJcWoY-8zA&list=PLd6WEu38CQSyebRIikg4qX54h-R1n35TG" target="_blank" class="fm-btn fm-btn-secondary">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
        <path fill="#FF3D00" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"></path><path fill="#FFF" d="M20 31L20 17 32 24z"></path>
      </svg>
      {{ t('tutorial') }}
    </a>
    <a href="https://wppool.dev/docs/how-to-enable-the-whatsapp-button-on-the-shop-page-and-product-page-using-formychat/" target="_blank" class="fm-btn fm-btn-secondary">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
        <linearGradient id="pg10I3OeSC0NOv22QZ6aWa_v0YYnU84T2c4_gr1" x1="-209.942" x2="-179.36" y1="-3.055" y2="27.526" gradientTransform="translate(208.979 6.006)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#55adfd"></stop><stop offset="1" stop-color="#438ffd"></stop></linearGradient><path fill="url(#pg10I3OeSC0NOv22QZ6aWa_v0YYnU84T2c4_gr1)" d="M39.001,13.999v27c0,1.105-0.896,2-2,2h-26	c-1.105,0-2-0.895-2-2v-34c0-1.104,0.895-2,2-2h19l2,7L39.001,13.999z"></path><path fill="#fff" fill-rule="evenodd" d="M15.999,18.001v2.999	h17.002v-2.999H15.999z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M16.001,24.001v2.999	h17.002v-2.999H16.001z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M15.999,30.001v2.999	h12.001v-2.999H15.999z" clip-rule="evenodd"></path><linearGradient id="pg10I3OeSC0NOv22QZ6aWb_v0YYnU84T2c4_gr2" x1="-197.862" x2="-203.384" y1="-4.632" y2=".89" gradientTransform="translate(234.385 12.109)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#427fdb"></stop><stop offset="1" stop-color="#0c52bb"></stop></linearGradient><path fill="url(#pg10I3OeSC0NOv22QZ6aWb_v0YYnU84T2c4_gr2)" d="M30.001,13.999l0.001-9l8.999,8.999L30.001,13.999z"></path>
      </svg>
      {{ t('documentation') }}
    </a>
    <a href="https://wordpress.org/plugins/social-contact-form/" target="_blank" class="fm-btn fm-btn-secondary">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FFD700"/>
      </svg>
      {{ t('review_us') }}
    </a>
  </div>
</div>

<!-- Mobile Drawer Overlay -->
<transition name="fade">
 <div
   v-if="showMobileMenu"
   @click="showMobileMenu = false"
   class="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
 ></div>
</transition>

<!-- Mobile Drawer -->
<transition name="slide">
 <div
   v-if="showMobileMenu"
   class="md:hidden fixed left-0 top-0 bottom-0 w-64 bg-white shadow-xl z-50 flex flex-col"
 >
   <!-- Drawer Header -->
   <div class="flex items-center justify-between p-4 border-b border-gray-200">
     <h4 class="font-semibold text-gray-900">{{ t('menu') }}</h4>
     <button
       @click="showMobileMenu = false"
       class="flex items-center justify-center w-8 h-8 rounded hover:bg-gray-100 transition-colors"
     >
       <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
       </svg>
     </button>
   </div>

   <!-- Drawer Navigation -->
   <nav class="flex-1 overflow-y-auto p-4 space-y-2">
     <router-link
       v-for="page in pages"
       :key="page.id"
       :to="page.to"
       @click="showMobileMenu = false"
       :class="[
         'w-full text-left px-4 py-3 rounded text-sm font-medium transition-colors flex items-center gap-3 outline-none focus:outline-none focus:ring-0 focus:border-0 focus-visible:outline-none focus-visible:ring-0',
         $route.path === page.to
           ? 'bg-indigo-600 text-white'
           : 'text-gray-700 hover:bg-gray-100'
       ]"
     >
       <component :is="page.icon" class="w-5 h-5" />
       <span>{{ page.label }}</span>
     </router-link>
   </nav>
 </div>
</transition>

<!-- Main Content Area -->
<div class="flex flex-col md:flex-row gap-4 md:gap-6 flex-1 overflow-hidden">

 <!-- Desktop Sidebar Navigation -->
 <div class="hidden md:block w-48 flex-shrink-0">
   <nav class="space-y-2">
     <router-link
       v-for="page in pages"
       :key="page.id"
       :to="page.to"
       :class="[
         'w-full text-left px-4 py-2 rounded text-sm font-medium transition-colors flex items-center gap-2 outline-none focus:outline-none focus:ring-0 focus:border-0 focus-visible:outline-none focus-visible:ring-0 !shadow-none',
         $route.path === page.to
           ? 'bg-indigo-600 text-white'
           : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900'
       ]"
     >
       <component :is="page.icon" class="w-5 h-5" />
       <span>{{ page.label }}</span>
     </router-link>
   </nav>
 </div>

 <!-- Content Area -->
 <div class="flex-1 overflow-y-auto bg-white p-3 sm:p-4 md:p-6 lg:p-8">
   <router-view />
 </div>

</div>
</div>
</template>

<script setup>
import { ref, h, onMounted } from 'vue';
import Toast from '@components/Toast.vue';
import Modal from './Modal.vue';
import { Upgrade } from '@components';
import { useCountries } from '@store/countries';
import { useTranslation } from '../composables/useTranslation';

const { t } = useTranslation();
const countriesStore = useCountries();
const showMobileMenu = ref(false);

onMounted(() => {
 countriesStore.fetch();
});

// Icons as functional components
const ShopIcon = () => h('svg', { class: 'w-5 h-5', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' }, [
 h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z' })
]);

const ProductIcon = () => h('svg', { class: 'w-5 h-5', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' }, [
 h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4' })
]);

const CartIcon = () => h('svg', { class: 'w-5 h-5', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' }, [
 h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z' })
]);

const CheckoutIcon = () => h('svg', { class: 'w-5 h-5', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' }, [
 h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z' })
]);

const pages = [
 { id: 'shop', label: t('shop_page'), icon: ShopIcon, to: '/shop' },
 { id: 'product', label: t('product_page'), icon: ProductIcon, to: '/product' },
 { id: 'cart', label: t('cart_page'), icon: CartIcon, to: '/cart' },
 { id: 'checkout', label: t('checkout_page'), icon: CheckoutIcon, to: '/checkout' },
];
</script>

<style scoped> 
/* Remove focus styles from nav links */
nav a:focus,
nav a:focus-visible {
 outline: none !important;
 box-shadow: none !important;
 border-color: transparent !important;
}

/* Header action buttons */
.fm-header-actions {
 display: flex;
 gap: 12px;
 align-items: center;
}

.fm-btn {
 padding: 8px 16px;
 border-radius: 20px;
 border: 1px solid;
 cursor: pointer;
 font-size: 14px;
 font-weight: 500;
 text-decoration: none;
 display: inline-flex;
 align-items: center;
 gap: 6px;
 transition: all 0.2s;
 background: rgb(232, 232, 232);
}

.fm-btn-secondary {
 border-color: #e5e7eb;
 color: #374151;
}

.fm-btn-secondary:hover {
 background: #f9fafb;
 border-color: #d1d5db;
}

/* Fade transition for overlay */
.fade-enter-active,
.fade-leave-active {
 transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
 opacity: 0;
}

/* Slide transition for drawer */
.slide-enter-active,
.slide-leave-active {
 transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
 transform: translateX(-100%);
}
</style>